import { createApp } from 'vue'
import App from './App.vue'
import VueRewards from "vue-rewards";
createApp(App).mount('#app')
const app = createApp(App);
app.use(VueRewards);
